import $ from 'jquery';

window.jQuery = $;
window.$ = $;
window.WMKS = window.WMKS ?? {};
